export const ROLE_LABELS = {
  // Plattform-Ebene (intern)
  platform_admin: "Plattform-Admin",
  platform_support: "Plattform · Support",
  platform_billing: "Plattform · Buchhaltung",
  platform_tech: "Plattform · Technik",
  platform_sales: "Plattform · Vertrieb",
  platform_compliance: "Plattform · Compliance",
  // Mandant
  super_admin: "Super-Admin",
  admin: "Administrator",
  management: "Geschäftsführung",
  manager: "Objektbetreuer",
  accountant: "Buchhaltung",
  support: "Support",
  vermietung: "Vermietung",
  external_service: "Externer Dienstleister",
  clerk: "Sachbearbeiter",
  external: "Externer Dienstleister",
  owner: "Eigentümer",
  tenant: "Mieter",
  viewer: "Leserechte",
};

export const PROPERTY_TYPES = {
  single_family: "Einfamilienhaus",
  two_family: "Zweifamilienhaus",
  multi_generation: "Mehrgenerationenhaus",
  semi_detached: "Doppelhaushälfte",
  row_end: "Reihenendhaus",
  row_middle: "Reihenmittelhaus",
  bungalow: "Bungalow",
  multi_family: "Mehrfamilienhaus",
  high_rise: "Hochhaus",
  residential_complex: "Wohnanlage",
  office: "Bürogebäude",
  retail: "Ladenlokal",
  commercial: "Gewerbeobjekt",
  mixed_use: "Gemischt genutzt",
  warehouse: "Lagerhalle",
  medical: "Praxisgebäude",
  other: "Sonstige Immobilie",
};

export const UNIT_TYPES = {
  apartment: "Wohnung",
  souterrain: "Souterrainwohnung",
  ground_floor: "Erdgeschosswohnung",
  floor_apartment: "Etagenwohnung",
  maisonette: "Maisonettewohnung",
  attic: "Dachgeschosswohnung",
  penthouse: "Penthouse",
  office: "Büro",
  retail: "Ladenlokal",
  medical: "Praxisfläche",
  storage: "Lagerfläche",
  garage: "Garage",
  parking: "Stellplatz",
  cellar: "Kellerraum",
  commercial: "Gewerbeeinheit",
  other: "Sonstige Einheit",
};

export const UNIT_STATUS = {
  rented: { label: "Vermietet", className: "bg-emerald-100 text-emerald-800 border border-emerald-200" },
  vacant: { label: "Leer", className: "bg-amber-100 text-amber-800 border border-amber-200" },
  reserved: { label: "Reserviert", className: "bg-blue-100 text-blue-800 border border-blue-200" },
  cancelled: { label: "Gekündigt", className: "bg-rose-100 text-rose-800 border border-rose-200" },
  renovation: { label: "In Renovierung", className: "bg-slate-200 text-slate-800 border border-slate-300" },
};

export const TENANCY_STATUS = {
  draft: { label: "Entwurf", className: "bg-slate-100 text-slate-700 border border-slate-200" },
  active: { label: "Aktiv", className: "bg-emerald-100 text-emerald-800 border border-emerald-200" },
  terminated: { label: "Gekündigt", className: "bg-amber-100 text-amber-800 border border-amber-200" },
  ended: { label: "Beendet", className: "bg-slate-100 text-slate-700 border border-slate-200" },
  vacant: { label: "Leerstand", className: "bg-amber-100 text-amber-800 border border-amber-200" },
  handover: { label: "In Übergabe", className: "bg-blue-100 text-blue-800 border border-blue-200" },
  archived: { label: "Archiviert", className: "bg-slate-100 text-slate-500 border border-slate-200" },
};

export const TASK_STATUS = {
  open: { label: "Offen", className: "bg-blue-100 text-blue-800 border border-blue-200" },
  in_progress: { label: "In Bearbeitung", className: "bg-amber-100 text-amber-800 border border-amber-200" },
  done: { label: "Erledigt", className: "bg-emerald-100 text-emerald-800 border border-emerald-200" },
  cancelled: { label: "Abgebrochen", className: "bg-slate-100 text-slate-600 border border-slate-200" },
};

export const TASK_PRIORITY = {
  low: { label: "Niedrig", className: "bg-slate-100 text-slate-700" },
  medium: { label: "Mittel", className: "bg-blue-100 text-blue-800" },
  high: { label: "Hoch", className: "bg-amber-100 text-amber-800" },
  urgent: { label: "Dringend", className: "bg-rose-100 text-rose-800" },
};

export const CONTACT_ROLES = {
  tenant: "Mieter",
  lessee: "Pächter",
  owner: "Eigentümer",
  leaseholder_grantor: "Erbpachtgeber",
  leaseholder: "Erbpächter",
  manager: "Verwalter",
  external_weg: "Fremd-verwaltete WEG",
  supplier: "Lieferant",
  prospect: "Interessent",
  bank: "Bank/Institut",
  insurance: "Versicherung",
  tradesperson: "Handwerker",
  lawyer: "Rechtsanwalt",
  tax_advisor: "Steuerberater",
  authority: "Behörde",
  caretaker: "Hausmeister",
  beirat: "Beirat",
  // Gerichte (2026-02)
  court_local: "Amtsgericht",
  court_regional: "Landgericht",
  court_higher: "Oberlandesgericht",
  court_federal: "Bundesgerichtshof",
  court_dunning: "Mahngericht",
  court_insolvency: "Insolvenzgericht",
  court_labor: "Arbeitsgericht",
  court_administrative: "Verwaltungsgericht",
  court_finance: "Finanzgericht",
  court_social: "Sozialgericht",
  court_agriculture: "Landwirtschaftsgericht / Höfe",
  // Behörden & öffentliche Stellen
  bailiff: "Gerichtsvollzieher",
  notary: "Notar",
  public_prosecutor: "Staatsanwaltschaft",
  police: "Polizei",
  tax_office: "Finanzamt",
  city_hall: "Stadt-/Gemeindeverwaltung",
  chamber: "Kammer (IHK/HWK/…)",
  // Versorger & Dienstleister
  utility: "Versorger (Strom/Gas/Wasser)",
  waste_management: "Abfallwirtschaft",
  chimney_sweep: "Schornsteinfeger",
  architect: "Architekt/Ingenieur",
  energy_advisor: "Energieberater",
  appraiser: "Sachverständiger",
  association: "Verein/Genossenschaft",
  media: "Rundfunk/Presse",
  other: "Sonstige",
};

// Gruppierte Ansicht für die Rollen-Auswahl (Contacts-Formular)
export const CONTACT_ROLE_GROUPS = [
  { label: "Miete & Eigentum",
    roles: ["tenant", "lessee", "owner", "leaseholder_grantor", "leaseholder", "prospect", "manager", "external_weg", "beirat"] },
  { label: "Dienstleister",
    roles: ["supplier", "tradesperson", "caretaker", "utility", "waste_management", "chimney_sweep",
            "architect", "energy_advisor", "appraiser"] },
  { label: "Rechtsberatung",
    roles: ["lawyer", "notary", "tax_advisor", "bailiff"] },
  { label: "Gerichte",
    roles: ["court_local", "court_regional", "court_higher", "court_federal", "court_dunning",
            "court_insolvency", "court_labor", "court_administrative", "court_finance",
            "court_social", "court_agriculture"] },
  { label: "Behörden & Öffentlich",
    roles: ["authority", "public_prosecutor", "police", "tax_office", "city_hall", "chamber", "media"] },
  { label: "Finanzen & Verein",
    roles: ["bank", "insurance", "association"] },
  { label: "Sonstiges",
    roles: ["other"] },
];

// P2 — Vorschläge für 1. Adresszeile („An das …", „An die …", „An den …")
export const ADDRESS_LINE1_SUGGESTIONS = {
  court_local: "An das Amtsgericht",
  court_regional: "An das Landgericht",
  court_higher: "An das Oberlandesgericht",
  court_federal: "An den Bundesgerichtshof",
  court_dunning: "An das Amtsgericht — Mahnabteilung",
  court_insolvency: "An das Insolvenzgericht",
  court_labor: "An das Arbeitsgericht",
  court_administrative: "An das Verwaltungsgericht",
  court_finance: "An das Finanzgericht",
  court_social: "An das Sozialgericht",
  court_agriculture: "An das Landwirtschaftsgericht",
  bailiff: "An den Gerichtsvollzieher",
  notary: "An das Notariat",
  public_prosecutor: "An die Staatsanwaltschaft",
  police: "An die Polizei",
  tax_office: "An das Finanzamt",
  city_hall: "An die Stadtverwaltung",
  chamber: "An die Kammer",
  authority: "An die Behörde",
};

export function suggestAddressLine1(contact) {
  if (!contact) return "";
  const roles = contact.roles || [];
  for (const r of roles) {
    if (ADDRESS_LINE1_SUGGESTIONS[r]) return ADDRESS_LINE1_SUGGESTIONS[r];
  }
  // Fallback per contact_type
  if (contact.contact_type === "court") return "An das Gericht";
  if (contact.contact_type === "authority_office") return "An die Behörde";
  return "";
}

export const ADDRESS_LINE1_COMMON = [
  "An das", "An die", "An den",
  "An das Amtsgericht", "An das Landgericht", "An das Oberlandesgericht",
  "An die Staatsanwaltschaft", "An das Finanzamt", "An den Gerichtsvollzieher",
];

export const POSTING_CATEGORIES = {
  rent_cold: "Kaltmiete",
  utilities: "Nebenkosten",
  heating: "Heizkosten",
  parking: "Stellplatz",
  other: "Sonstiges",
  deposit: "Kaution",
  fee: "Gebühr",
  dunning_fee: "Mahngebühr",
  refund: "Rückzahlung",
  vat: "Umsatzsteuer",
  bka: "BKA-Nachzahlung",
  surplus: "Überschuss / Guthaben",
  claim: "Forderung",
  damages: "Schadensersatz",
  interest: "Verzugszinsen",
  legal_costs: "Rechtsverfolgungskosten",
  consolidated: "Zusammengefasst",
};

// Kategorien für Split-/Zuordnungs-Dialoge (Soll ↔ Haben je Kategorie)
export const LEDGER_CATEGORY_OPTIONS = [
  ["rent_cold", "Kaltmiete"],
  ["utilities", "Nebenkosten"],
  ["heating", "Heizkosten"],
  ["parking", "Stellplatz"],
  ["vat", "Umsatzsteuer"],
  ["bka", "BKA-Nachzahlung"],
  ["claim", "Forderung"],
  ["damages", "Schadensersatz"],
  ["interest", "Verzugszinsen"],
  ["legal_costs", "Rechtsverfolgungskosten"],
  ["fee", "Gebühr"],
  ["dunning_fee", "Mahngebühr"],
  ["other", "Sonstiges"],
];

// Phase 21α – Gruppierte Kategorien für die Anlage von Miet- & NK-Regeln.
// Strukturierte Hierarchie: Miete / Betriebskosten / Stellplatz / Sonstiges.
export const POSTING_CATEGORY_GROUPS = [
  {
    key: "rent",
    label: "Miete",
    items: [
      { value: "rent_cold", label: "Kaltmiete", icon: "Currency" },
    ],
  },
  {
    key: "operating",
    label: "Betriebskosten",
    items: [
      { value: "utilities", label: "Nebenkosten" },
      { value: "heating",   label: "Heizkosten" },
    ],
  },
  {
    key: "parking",
    label: "Stellplatz",
    items: [
      { value: "parking", label: "Stellplatzmiete" },
    ],
  },
  {
    key: "other",
    label: "Sonstige",
    items: [
      { value: "other",   label: "Sonstiges" },
      { value: "deposit", label: "Kaution" },
      { value: "fee",     label: "Gebühr" },
      { value: "refund",  label: "Rückzahlung" },
      { value: "surplus", label: "Überschuss / Guthaben" },
    ],
  },
  {
    key: "claims",
    label: "Forderungen",
    items: [
      { value: "claim",       label: "Forderung" },
      { value: "damages",     label: "Schadensersatz" },
      { value: "interest",    label: "Verzugszinsen" },
      { value: "legal_costs", label: "Rechtsverfolgungskosten" },
      { value: "bka",         label: "BKA-Nachzahlung" },
      { value: "dunning_fee", label: "Mahngebühr" },
    ],
  },
];

export const METER_TYPES = {
  heat_quantity: "Wärmemenge",
  hot_water: "Warmwasser",
  cold_water: "Kaltwasser",
  electricity: "Strom",
  gas: "Gas",
  heat_cost_allocator: "Heizkostenverteiler",
  district_heating: "Fernwärme",
  common_electricity: "Allgemeinstrom",
  other: "Sonstige",
};

export const METER_UNIT_SUGGESTION = {
  heat_quantity: "kWh",
  hot_water: "m³",
  cold_water: "m³",
  electricity: "kWh",
  gas: "m³",
  heat_cost_allocator: "Einheiten",
  district_heating: "kWh",
  common_electricity: "kWh",
  other: "",
};

export const INSURANCE_TYPES = {
  building: "Gebäudeversicherung",
  liability: "Haftpflicht",
  glass: "Glasversicherung",
  elemental: "Elementarschaden",
  contents: "Inhalt/Inventar",
  legal: "Rechtsschutz",
  other: "Sonstige",
};

export const HEATING_TYPES = {
  central: "Zentralheizung",
  floor: "Etagenheizung",
  district: "Fernwärme",
  heat_pump: "Wärmepumpe",
  single_stove: "Einzelofen",
};

export const HEATING_ENERGIES = {
  gas: "Gas",
  oil: "Öl",
  lpg: "Flüssiggas (Tank)",
  electric: "Strom",
  pellets: "Pellets",
  district: "Fernwärme",
  solar: "Solar",
};

export const HOT_WATER_TYPES = {
  central: "Zentral",
  decentral: "Dezentral",
  flow_heater: "Durchlauferhitzer",
  boiler: "Boiler",
};

export const ENERGY_CERT_TYPES = {
  consumption: "Verbrauch",
  demand: "Bedarf",
};

export const SALUTATIONS = {
  herr: "Herr",
  frau: "Frau",
  divers: "Divers",
};

export const TENANCY_TYPES = {
  "01": "Wohnraummietvertrag",
  "02": "Gewerbemietvertrag",
  "03": "Kellermietvertrag",
  "04": "Speichermietvertrag",
  "05": "Außenstellplatzmietvertrag",
  "06": "Tiefgaragenstellplatzmietvertrag",
};

// Dokument-Kategorien (verwendet in Dokumenten-Listen & Uploads)
export const DOCUMENT_CATEGORIES = [
  "Verträge",
  "Vertragsänderung",
  "Betriebskosten",
  "Nebenkosten",
  "Korrespondenz",
  "Übergabeprotokoll",
  "Amtliche Dokumente",
  "Mieterhöhung",
  "Versicherung",
  "Versandnachweis",
  "Rechnungen",
  "Fotos",
  "Sonstiges",
];

export const RENT_TYPES = {
  normal: "Normale Miete",
  index: "Indexmiete",
  staffel: "Staffelmiete",
  social: "Sozialwohnung",
};

export const DEPOSIT_STATUS_LABELS = {
  none: "Keine Kaution",
  open: "Ausstehend",
  partial: "Teilweise gezahlt",
  paid: "Vollständig gezahlt",
};

export const PAYMENT_METHODS = {
  sepa: "SEPA-Lastschrift",
  bank_transfer: "Überweisung",
  cash: "Bar",
  standing_order: "Dauerauftrag",
  other: "Sonstiges",
};

// Deutsche Verbraucherpreis-Index Basis-Jahre (Statistisches Bundesamt)
export const INDEX_BASES = {
  "2020": "Basis 2020 = 100 (aktuell)",
  "2015": "Basis 2015 = 100",
  "2010": "Basis 2010 = 100",
  "2005": "Basis 2005 = 100",
  "2000": "Basis 2000 = 100",
};

export function formatEUR(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n);
}

export function formatDate(s) {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  // Spec: immer TT.MM.JJJJ (zero-padded)
  const longFmt = typeof document !== "undefined" && document.documentElement?.dataset?.dateFormat === "TT. Monat JJJJ";
  if (longFmt) {
    return d.toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" });
  }
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function contactDisplayName(c) {
  if (!c) return "—";
  if (c.contact_type === "person") {
    return [c.first_name, c.last_name].filter(Boolean).join(" ") || c.company_name || "—";
  }
  return c.company_name || c.contact_person || "—";
}


// ---------------------------------------------------------------------------
// 2026-08 · Root-Cause-Fix „weißer Bildschirm beim Suchen von Kontakten"
// ---------------------------------------------------------------------------
// Backend-Modell: contact.emails ist ``List[Union[str, LabeledEmail]]``, wobei
// LabeledEmail ein Object mit ``{email, label, is_primary}`` ist. Wenn eine
// Komponente ``{c.emails[0]}`` direkt als React-Child rendert und die erste
// Adresse ein Object ist, wirft React ``Objects are not valid as a React
// child`` — was die gesamte Komponente unmountet und einen weißen Bildschirm
// hinterlässt.
//
// Ab jetzt STETS ``displayEmail`` / ``firstEmail`` / ``emailListToText``
// verwenden, nirgends ``c.emails[0]`` roh in JSX. Ebenso gilt: alle Felder,
// die Objects enthalten könnten (bank_accounts, contact_persons, ...), müssen
// mit einem Adapter durch primitive Strings ersetzt werden, bevor sie ins
// JSX gehen.

/** Wandelt ein E-Mail-Element (String ODER {email,label,is_primary}) sicher in
 * einen anzeigbaren String um. Nie ein Object zurückgeben.
 */
export function displayEmail(e) {
  if (!e) return "";
  if (typeof e === "string") return e;
  if (typeof e === "object") return String(e.email || "");
  return String(e);
}

/** Liefert die "beste" (primary → erste) Adresse eines Kontakts als String. */
export function firstEmail(list) {
  if (!Array.isArray(list) || list.length === 0) return "";
  const primary = list.find((e) => typeof e === "object" && e && e.is_primary);
  return displayEmail(primary || list[0]);
}

/** Flacht die Adressen-Liste sicher für Suchindizes / join-Operationen ab. */
export function emailListToText(list) {
  if (!Array.isArray(list)) return "";
  return list.map(displayEmail).filter(Boolean).join(" ");
}

/** Sichere Alternative zu ``phones.join(" ")`` — falls doch mal ein Object drin liegt. */
export function phoneListToText(list) {
  if (!Array.isArray(list)) return "";
  return list.map((p) => (typeof p === "string" ? p : (p?.number || p?.phone || ""))).filter(Boolean).join(" ");
}

/** Liefert die "beste" Telefonnummer eines Kontakts als reinen String.
 *  Verhindert React-Error #31, wenn phones = [{number, label, is_primary}] ist. */
export function firstPhone(list) {
  if (!Array.isArray(list) || list.length === 0) return "";
  const toStr = (p) => (typeof p === "string" ? p : (p?.number || p?.phone || ""));
  const primary = list.find((p) => typeof p === "object" && p && p.is_primary);
  return toStr(primary || list[0]);
}

export const FUEL_TANKS = { none: "Keine Tankanlage", oil: "Öltank", lpg: "Gastank (Flüssiggas)" };
export const tankFuelOf = (p) => (p?.fuel_tank ? (p.fuel_tank === "none" ? null : p.fuel_tank) : (["oil", "lpg"].includes(p?.heating_energy) ? p.heating_energy : null));
